import { Injectable } from '@angular/core';

import * as moment from 'moment';

@Injectable()
export class SearchFlightFormService {

    private dateFormat: string = "YYYY-MM-DD";

    public buildJSON(research: any) {
        return {
            "segment":
            [
                {
                    "from": research.segment[0].from,
                    "to": research.segment[0].to,
                    "begin": moment(research.segment[0].date).format(this.dateFormat)
                },
                {
                    "from": research.segment[1].from,
                    "to": research.segment[1].to,
                    "begin": moment(research.segment[1].date).format(this.dateFormat)
                }
            ],
            "quantity": {
                "adult": research.quantity.adult,
                "child": research.quantity.child,
                "infant": research.quantity.infant
            }
        };
    }
}
